import { gql } from '@apollo/client'

export const USER_PRIORITIES = gql`
  query UserPriorities($userId: Int!) {
    userSurveyPriorities(userId: $userId) {
      id
      rank
      category
      confidenceLevel
      challenges
      createdAt
    }
  }
`
